import * as React from "react";
import ReactHtmlParser from 'react-html-parser';

export interface IWebshopProductDetail {
  productName: string;
  imageUrl: string;
  productShortInfo: string;
  productDescription: string;
}
export const WebshopProductDetail = (props: IWebshopProductDetail) => {
  return (
    <div className="col-12 webshop-product-detail">
      <div className="webshop-product-detail__product-detail-image">
        <img src={props.imageUrl} />
      </div>
      <h3 className="webshop-product-detail__label">Productdetails</h3>
      <div className="webshop-product-detail__product-short-info">
        {ReactHtmlParser(props.productShortInfo)}
      </div>
      <h3 className="webshop-product-detail__label">Productomschrijving</h3>
      <div className="webshop-product-detail__product-description">
        {ReactHtmlParser(props.productDescription)}
      </div>      
    </div>
  );
};
